import axios from "./api-client";
import API from "../constants/apis";

export const getAllRedeemings = async () => {
    return axios.get(API.GET_ALL_REDEEMINGS);
};

export const createRedeem = async (data) => {
    return axios.post(API.REDEEM, data);
};

export const createRedeemViaPaypal = async (data) => {
    return axios.post(API.REDEEM_VIA_PAYPAL, data);
};
